export const LoadType= {
    inbound: 'Inbound',
    outbound: 'Outbound'
} as const;

